module.exports = __webpack_public_path__ + "static/media/2.6ba02ead.png";